import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button';
import TooltipOverlay from 'components/UI/TooltipOverlay';
import { useRefreshCartOnFocus } from 'hooks/useRefreshCartOnFocus';
import { t } from 'i18next';
import Footer from 'modules/customer/components/Footer';
import MobileFooterBar from 'modules/customer/components/Footer/MobileFooterBar';
import Navbar from 'modules/customer/components/Header/Navbars';
import { lazy, Suspense, useCallback, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import 'modules/customer/assets/scss/customerCustom.scss';

const AgeVerificationModal = lazy(
  () => import('modules/customer/components/Header/Modals/AgeVerificationModal')
);

export default function CustomerMainLayout() {
  const [isVisible, setIsVisible] = useState(false);

  // keep the cart in step when the same account changes it in another tab or device
  useRefreshCartOnFocus();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 1500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div className="customer-layout customer-dark-layout min-vh-100 d-flex flex-column">
      {/* Age Verification — renders only for unauthenticated visitors */}
      <Suspense fallback={null}>
        <AgeVerificationModal />
      </Suspense>

      <div className="d-flex flex-column flex-grow-1">
        {/* <TopNavBar /> */}
        <Navbar />
        <Container fluid className="content content-mainsection p-0 flex-grow-1 d-flex flex-column">
          <Outlet />
        </Container>
        <Footer />
        <MobileFooterBar />
      </div>
      {isVisible && (
        <Button className="scroll-to-top-btn" onClick={scrollToTop} aria-label={t('scroll_to_top')}>
          <TooltipOverlay placement="top" title={t('scroll_to_top')}>
            <FontAwesomeIcon icon={faChevronUp} />
          </TooltipOverlay>
        </Button>
      )}
    </div>
  );
}
